// extracted by mini-css-extract-plugin
export default {"wrapper":"ActivityPost_wrapper__1qQTe","hr":"ActivityPost_hr__0haR3","pagination":"ActivityPost_pagination__cYKOQ","wrapperTooltip":"ActivityPost_wrapperTooltip__+xxbH"};